import { ToastManagerRepository } from "@core/domain/repositories/toast-manager.repository.ts";
import type {
    Report,
    ReportHistoricalCustomFilter,
} from "@report/domain/models/report.model";
import type { ReportRepository } from "@report/domain/repositories/report.repository";
import { reportTypes } from "@report/report-types.di";
import { inject, injectable } from "inversify";

@injectable()
export class ReportGetHistoricalCustomUseCase {
    constructor(
        @inject(reportTypes.repositories.ReportRepository)
        private readonly reportRepository: ReportRepository,
    ) {}

    async execute(
        historicalCustomFilters: ReportHistoricalCustomFilter,
    ): Promise<Report[]> {
        const historicalCustomReportResult =
            await this.reportRepository.fetchHistoricalCustomReport(
                historicalCustomFilters,
            );

        if (historicalCustomReportResult.isErr()) {
            ToastManagerRepository.error(
                historicalCustomReportResult.error.message,
            );
        }
        return historicalCustomReportResult.match(
            (historicalCustomReport) => historicalCustomReport,
            () => [],
        );
    }
}
